module.exports = __webpack_public_path__ + "img/dashboard-truck-delivered.29306eff.svg";